export const environment = {
  production: false,

  // the successful login return url
  authRedirectURI: 'http://localhost:4201/login/success/',
  canChangeBE: false,
};
